import { useState } from 'react';
import { IconButton, Alert, Dialog } from '@mui/material';
import { Formik, Form } from 'formik';
import FormikControl from 'src/components/InputControls/FormikControl';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useSnackbar } from 'notistack';
import {
  FlexEndGridContainer,
  GridContainer,
  GridItem,
  StyledButton
} from 'src/components/StyledComponents/Index';
import { CreateParentTitle } from 'src/components/StyledComponents/ParentDashboard';
import SuspenseLoader from 'src/components/SuspenseLoader';
import { createStudent } from 'src/services/Parent/parent.service';
import { addStudentValidationSchema } from 'src/utils/validationSchema.utils';

export interface CreateStudentProps {
  open: boolean;
  onClose: () => void;
}

export default function CreateStudent(props: CreateStudentProps) {
  const { onClose, open } = props;

  const { enqueueSnackbar } = useSnackbar();

  const [errorMsg, setErrorMsg] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [initialValues] = useState({
    firstName: '',
    lastName: '',
    email: '',
    dateOfBirth: ''
  });

  const handleClose = () => {
    onClose();
    setErrorMsg('');
  };

  const onSubmit = (values) => {
    setIsLoading(true);
    const input = {
      ...values,
      email: values.email.toLowerCase()
    };
    createStudent(input).then(
      (response: any) => {
        setIsLoading(false);
        onClose();
        setErrorMsg('');
        enqueueSnackbar(response.message, { variant: 'success' });
      },
      (error: any) => {
        setIsLoading(false);
        setErrorMsg(JSON.parse(error.data.message).details.message);
      }
    );
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      scroll="paper"
      sx={{
        overFlowY: 'auto'
      }}
    >
      <GridContainer justifyContent="center">
        <GridItem md={12}>
          <FlexEndGridContainer>
            <IconButton
              aria-label="delete"
              onClick={handleClose}
              size={'small'}
            >
              <HighlightOffIcon />
            </IconButton>
          </FlexEndGridContainer>
        </GridItem>
        <Formik
          initialValues={initialValues}
          validationSchema={addStudentValidationSchema}
          onSubmit={onSubmit}
        >
          {() => (
            <Form>
              <GridItem md={12}>
                <GridContainer
                  justifyContent="center"
                  p="40px "
                  rowSpacing="26px"
                >
                  <GridItem md={8} xs={12}>
                    <CreateParentTitle>Add Student</CreateParentTitle>
                  </GridItem>
                  <GridItem md={8}>
                    {errorMsg && <Alert severity="error">{errorMsg}</Alert>}
                  </GridItem>
                  <GridItem md={8} xs={12}>
                    <FormikControl
                      control="input"
                      type="text"
                      label="First Name"
                      name="firstName"
                    />
                  </GridItem>
                  <GridItem md={8} xs={12}>
                    <FormikControl
                      control="input"
                      type="text"
                      label="Last Name"
                      name="lastName"
                    />
                  </GridItem>
                  <GridItem md={8} xs={12}>
                    <FormikControl
                      control="input"
                      type="email"
                      label="E-mail"
                      name="email"
                    />
                  </GridItem>
                  <GridItem md={8} xs={12}>
                    <FormikControl
                      control="input"
                      type="date"
                      label="Date of Birth"
                      name="dateOfBirth"
                      InputLabelProps={{ shrink: true }}
                    />
                  </GridItem>
                  <GridItem md={8} xs={12}>
                    <StyledButton type="submit" fullWidth variant="contained">
                      Add Student
                    </StyledButton>
                  </GridItem>
                </GridContainer>
              </GridItem>
            </Form>
          )}
        </Formik>
      </GridContainer>
      {isLoading && <SuspenseLoader />}
    </Dialog>
  );
}
